var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.179 16.8a6.65 6.65 0 0 1-2.382-5.1c0-2.042.924-3.87 2.382-5.1A6.8 6.8 0 0 0 7.781 5C4.036 5 1 8 1 11.7s3.036 6.7 6.78 6.7a6.8 6.8 0 0 0 4.399-1.6",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.179 16.8a6.65 6.65 0 0 0 2.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.65 6.65 0 0 0-2.382 5.1c0 2.042.924 3.87 2.382 5.1",
  clipRule: "evenodd",
  opacity: 0.7
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.179 16.8a6.65 6.65 0 0 0 2.382-5.1c0-2.042-.924-3.87-2.382-5.1A6.8 6.8 0 0 1 16.577 5c3.745 0 6.78 3 6.78 6.7s-3.035 6.7-6.78 6.7a6.8 6.8 0 0 1-4.398-1.6",
  clipRule: "evenodd",
  opacity: 0.2,
  style: {
    mixBlendMode: "multiply"
  }
}));
export default SvgMastercardIcon;